"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.defaultTranslationsWithNamespaces = void 0;
var _languageSwitcher = require("@ori/language-switcher");
var _defaultTranslations = require("./defaultTranslations");
/**
 * Combined translations with namespaces that footer uses. Includes footer and language-switcher namespaces
 */
const defaultTranslationsWithNamespaces = exports.defaultTranslationsWithNamespaces = {
  [_defaultTranslations.translationsNamespace]: _defaultTranslations.defaultTranslations,
  [_languageSwitcher.translationsNamespace]: _languageSwitcher.defaultTranslations
};